<button (click)="performOperation('minus')">-</button>
<input type="number" [value]="donutData.onshore"/>
<button  (click)="performOperation('plus')">+</button>
<div style="display: none;" id="chart"></div>